(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lz-discovery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lz-discovery]').forEach(root=>{
 const form=root.querySelector('form'),result=root.querySelector('[data-discovery-result]'),catalog=JSON.parse(root.querySelector('[data-discovery-catalog]').textContent);
 form.addEventListener('submit',event=>{
  event.preventDefault();const data=new FormData(form),scores=new Map(catalog.map(p=>[p.handle,0]));
  const add=(handles,n)=>handles.forEach(h=>scores.set(h,(scores.get(h)||0)+n));
  add([data.get('presence')],3);
  if(data.get('texture')==='fresh')add(['seduction','desire'],2);
  if(data.get('texture')==='wood')add(['allure','empire'],2);
  if(data.get('texture')==='rich')add(['sinful','wealth','what-happens-after'],2);
  if(data.get('moment')==='everyday')add(['allure','desire','seduction'],2);
  if(data.get('moment')==='evening')add(['sinful','wealth','what-happens-after'],2);
  if(data.get('moment')==='occasion')add(['empire','wealth','seduction'],2);
  const chosen=catalog.filter(p=>p.identity).sort((a,b)=>scores.get(b.handle)-scores.get(a.handle)||(b.handle===data.get('presence')?1:0)-(a.handle===data.get('presence')?1:0))[0];if(!chosen)return;
  root.querySelector('[data-result-title]').textContent=chosen.title;root.querySelector('[data-result-copy]').textContent=chosen.identity.hook+' '+chosen.identity.occasion;root.querySelector('[data-result-notes]').textContent=chosen.identity.family;root.querySelector('[data-result-link]').href=chosen.url;
  form.hidden=true;result.hidden=false;result.focus();
 });
 root.querySelector('[data-discovery-reset]').addEventListener('click',()=>{form.hidden=false;result.hidden=true;form.reset();form.querySelector('input').focus();});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
